<template>
  <top-page-section class="pt-l pb-10">
    <div class="text-center font-bold  text-3xl uppercase">
      <slot/>
    </div>
  </top-page-section>
</template>

<script>

export default {
  name: 'TopPageTitle'
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

</style>
